'use strict';
var parent = require('../../es/object/from-entries');
require('../../modules/web.dom-collections.iterator');

module.exports = parent;



//////////////////
// WEBPACK FOOTER
// ./~/@okta/okta-auth-js/~/core-js/stable/object/from-entries.js
// module id = 493
// module chunks = 0